import { Component, DOCUMENT, inject, OnInit } from '@angular/core';
import { FadeInReveal } from '../../../../directives/fade-in-reveal';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-service-teen',
  imports: [CommonModule, RouterLink, FadeInReveal],
  templateUrl: './service-teen.html',
  styleUrls: ['./service-teen.less', '../services.less'],
})
export class ServiceTeen implements OnInit {
  private dom = inject(DOCUMENT);

  ngOnInit() {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Terapia para adolescentes',
      description:
        'Acompañamiento psicológico para adolescentes en procesos de identidad, emociones intensas, ansiedad y dificultades relacionales.',
      provider: { '@id': 'https://anapellonpsicologa.com' },
      areaServed: [
        {
          '@type': 'AdministrativeArea',
          name: 'Santander',
        },
        {
          '@type': 'Country',
          name: 'España',
        },
      ],
      availableChannel: [
        {
          '@type': 'ServiceChannel',
          serviceLocation: {
            '@type': 'Place',
            name: 'Consulta presencial en Santander',
          },
        },
        {
          '@type': 'ServiceChannel',
          serviceUrl: 'https://anapellonpsicologa.com/contacto',
        },
      ],
    };

    const script = this.dom.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    this.dom.head.appendChild(script);
  }
}
